import Load from "./birthday/load";
import Thanks from "./birthday/thanks";
const load = new Load();
const thanks = new Thanks();